import Request from '@/core/QuRequest';

import * as $cache from '@/common/cache';

const req = new Request();

export default {
  methods: {
    // 获取公共参数
    getParams() {
      const [start, end] = this.date;
      const params = {
        start_date: start.format(this.$REQUEST_DATE_FORMAT),
        end_date: end.format(this.$REQUEST_DATE_FORMAT),
        stop_days: this.stopDays,
        keyword: this.keyword,
        aggregatedType: this.aggregatedType,
        budgetType: this.budgetType
      };
      return params;
    },

    // 获取汇总信息
    async querySummary() {
      const params = this.getParams();
      const data = await req.send(req.Apis.sales.report.productReportSummary, params);

      try {
        const { list, latestTime } = data.data;
        this.summary = list;
        this.summaryLoading = false;
        this.lastUpdateTime = latestTime;
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    // 获取停投产品数
    async queryStopProductSummary() {
      const params = this.getParams();
      const data = await req.send(req.Apis.sales.report.productReportSummaryStop, params);

      try {
        this.summary = this.summary.map(item => {
          if (item.key === data.data.key) return data.data;
          return item;
        });
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    // 获取汇总折线图数据
    async queryMyPerformance() {
      const params = this.getParams();
      params.dimension = this.dimension;
      params.index = this.field;
      params.sale_type = this.sale_type;
      // params.name = this.name;
      params.account_ids = this.account_ids;
      // params.sale_name = this.sale_name;
      params.budget_ids = this.budget_ids ?  this.budget_ids.join(',') : '';
      params.product_ids = this.product_ids ?  this.product_ids.join(',') : '';
      params.sale_ids = this.sale_ids ?  this.sale_ids.join(',') : '';
      params.product_series_ids = this.product_series_ids ?  this.product_series_ids.join(',') : '';
      params.customer_cate = this.customer_cate;

      const data = await req.send(req.Apis.sales.report.agentReportMyPerformance, params);

      try {
        this.rawChartData = data.data;
        this.chartLoading = false;
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    // 获取产品系列表
    async queryProductSeries(keyword) {
      const res = await req.send(req.Apis.customer.productSeries.list, {keyword: keyword});
      if(res.code === 200) {
        const {data} = res;
        this.productSeriesOptions = (data.list || []).map(item => {
          return {label: item.name, value: item.id}
        })
      }
    },

    // 获取聚合名称
    async queryAggregations(keyword) {
      const res = await req.send(req.Apis.customer.productSeries.aggregations, {
        page: 1,
        page_size: 100,
        keyword: keyword
      });
      if(res.code === 200) {
        const {data} = res;
        this.aggregationsOptions = (data.list || []).map(item => {
          return {label: item.budget_name, value: item.id}
        })
      }
    },

    // 获取产品名称
    async queryProducts(keyword) {
      const res = await req.send(req.Apis.customer.productSeries.products, {
        name: keyword,
        page: 1,
        page_size: 100,
      });
      if(res.code === 200) {
        const {data} = res;
        this.productsOptions = (data.data || []).map(item => {
          return {label: item.name, value: item.id}
        })
      }
    },

    // 获取销售名称/所属
    async queryProductSales(keyword) {
      const res = await req.send(req.Apis.customer.productSeries.sales, {
        names: keyword,
        page: 1,
        page_size: 100,
      });
      if(res.code === 200) {
        const {data} = res;
        this.salesOptions = (data.data || []).map(item => {
          return {label: item.name, value: item.adv_user_id}
        })
      }
    },


    // 获取 TOP20 折线图数据
    async queryTop20() {
      const params = this.getParams();
      params.dimension = this.dimension;
      params.index = this.field;
      params.sale_type = this.sale_type;
      // params.name = this.name;
      params.account_ids = this.account_ids;
      // params.sale_name = this.sale_name;

      params.budget_ids = this.budget_ids ?  this.budget_ids.join(',') : '';
      params.product_ids = this.product_ids ?  this.product_ids.join(',') : '';
      params.sale_ids = this.sale_ids ?  this.sale_ids.join(',') : '';

      params.product_series_ids = this.product_series_ids ?  this.product_series_ids.join(',') : '';
      params.customer_cate = this.customer_cate;

      const data = await req.send(req.Apis.sales.report.agentReportTop20, params);

      try {
        this.rawChartData = data.data;
        this.chartLoading = false;
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    // 获取详细数据列表
    async queryList() {
      const params = this.getParams();
      params.page = this.page;
      params.page_size = this.pageSize;
      params.order_by = this.order;
      params.fields = [...this.fields].join(',')
      params.budget_ids = this.budget_ids ?  this.budget_ids.join(',') : '';
      params.product_ids = this.product_ids ?  this.product_ids.join(',') : '';
      params.product_series_ids = this.product_series_ids ?  this.product_series_ids.join(',') : '';

      const data = await req.send(req.Apis.sales.report.kaReportList, params);
      try {
        this.tableLoading = false;
        this.rawTableData = data.data;
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    async download() {
      // const form = document.createElement('form');
      // form.id = 'downloadForm';
      // form.name = 'tableDownloadHelper';
      // document.body.appendChild(form);
      // for (let key in params) {
      //   if (params.hasOwnProperty(key)) {
      //     if (key !== 'filters') {
      //       const input = document.createElement('input');
      //       input.type = 'hidden';
      //       input.name = key;
      //       input.value = params[key];
      //       form.appendChild(input);
      //     } else {
      //       params[key].forEach((value) => {
      //         const input = document.createElement('input');
      //         input.type = 'hidden';
      //         input.name = 'filters[]';
      //         input.value = value;
      //         form.appendChild(input);
      //       });
      //     }
      //   }
      // }
      // form.method = 'POST';
      // form.action = req.getUrl(req.Apis.sales.report.productReportDownload);
      // form.submit();
      // document.body.removeChild(form);
    },
  },
};
